var render = function render(_c,_vm){return _c('div',{staticClass:"no-data",class:[{'no-data-jumbo' : _vm.props.jumbo}, {'no-data--shadow' : _vm.props.shadow}]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }